import { SourceBoundingBox } from '~/lib/pdfViewer/types';
import type { CommentedHighlight } from '~/components/ui/vendor/pdf/pdf_container/types';

export function fieldBBox2ReactPDFBBox(
  bbox: SourceBoundingBox,
): CommentedHighlight['position']['boundingRect'] {
  return {
    pageNumber: bbox.pageStart,
    x1: bbox.x1,
    x2: bbox.x2,
    y1: bbox.y1,
    y2: bbox.y2,
    // height: bbox.y2 - bbox.y1,
    height: 1,
    width: 1,
  };
}
